import { IDrop } from "src/core/drops/api/drops.api";

/**
 * Is a drop allowed to create holidays
 * @param drop
 * @returns boolean
 */
export const dropAllowedHolidays = (drop: IDrop | null): boolean => {
  return drop?.groupedSettings.allow_holidays?.value.allowed ?? false;
};
